<template>
  <div class="">
    <div class="bgfff w100b pb20 pl20 pr20 pt20 min-height bestRate">

      <Col class="demo-spin-col" style="height: 500px" v-if="loading">
      <Spin fix>
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
      </Col>

      <ul class="top-tab">
        <li class="cp" v-for="(item, index) in cuBankList" :key="item.bankName+index" :class="cuActiveBank === item.bankCode && 'active'">
          <span class="bank-color" :style="`background-color:`+$store.state.publicData.bankColor[item.bankCode]"></span>
          {{item.bankName}}
        </li>
      </ul>

      <discount-best-rate-card class="imageDom" ref="imageDom" v-if="activeInfo.activeType === 'rzline'" :cuDiscountRate="activeInfo.cuDiscountRate" :levelBankList="activeInfo.levelBankList" :logo="activeInfo.logo" :bank="activeInfo.bankName" :type="activeInfo.activeType" :cuActiveBank="cuActiveBank"></discount-best-rate-card>

    </div>
  </div>
</template>

<script>
import store from '@/store/store';
import Table from '../module/Table.vue';
import DiscountRateCardFm from '../common/DiscountRateCardFm.vue';
import { queryAll, queryBest, queryBankList } from '@/api/discountBankQuote.js'
import DiscountBestRateCard from '../common/DiscountBestRateCard.vue';
import DiscountRateCardXY from '../common/DiscountRateCardXY.vue';
import html2canvas from 'html2canvas';
export default {
  store, // 引用
  name: "discountRateMenu",
  provide () {
    return {
      discountBestWebBaseCom: this
    }
  },
  data () {
    return {
      // 京东利率
      quoteList: [],
      // 众邦振兴的利率
      discountRateVoList: {},
      cuDiscountRateVoList: {},
      // 富民利率
      fmRate: null,
      // 融资线配置的利率
      // rzlineConfigBankRateList: [],
      // 当前的银行列表
      cuBankList: [],
      activeInfo: {
        activeBank: null,
        // 当前选择的银行利率的渠道
        activeType: null,
        cuDiscountRate: [],
        levelBankList: null,
        logo: null,
        bankName: null,
        updateTime: ''
      },
      cuActiveBank: '',
      loading: true
    }
  },
  components: {
    DiscountRateCardFm,
    DiscountBestRateCard,
    DiscountRateCardXY
  },
  methods: {
    // 选择银行
    changeActiveBank (bank, info) {
      console.log(bank, info)
      this.activeInfo.activeBank = bank;
      this.activeInfo.activeType = info.type;
      this.activeInfo.cuDiscountRate = info.cuDiscountRate
      this.activeInfo.logo = info.bankCode
      this.activeInfo.levelBankList = info.levelBankList
      this.activeInfo.bankName = info.bankName
      this.activeInfo.updateTime = info.updateTime
      console.log(this.activeInfo)
    },
    // // 初始化rzl配置的银行利率
    // async getRzlineConfigBankRate () {
    //   return await queryAll();
    // },
    // 查询银行列表
    async refreshBankList () {
      return await queryBankList()
    },
    // 初始化最优报价的利率
    async getBestRate (param) {
      const res = await queryBest(param || '');
      console.log(res, '初始化最优报价的利率');
      return res;
    },
    // 票面范围处理
    getScope (start, end, index) {
      if (index == 0) {
        return "[" + start.div(10000).toFixed(0) + "," + end.div(10000).toFixed(0) + "]";
      } else {
        return "[" + start.div(10000).toFixed(0) + "," + end.div(10000).toFixed(0) + ")";
      }
    },
    // 利率
    changeRate (rate) {
      if (rate.indexOf('%') > -1) {
        return rate;
      } else {
        return Number(rate).mul(100).toFixed('2') + '%';
      }
    },
    async refreshBankRate () {
      this.addLoading();
      let bestRate = await this.getBestRate({ refreshBestQuote: true })
      let cuBestData = {
        bankName: bestRate.bankName,
        type: 'rzline',
        bankCode: bestRate.logo,
        cuDiscountRate: bestRate.cuDiscountRate,
        levelBankList: bestRate.levelBankList,
        updateTime: bestRate.updateTime
      }
      // 选择银行
      this.changeActiveBank(bestRate.bankName + '0', cuBestData)
    },
    downloadPage () {
      this.addLoading()
      let htmlDom = document.querySelector('.bestRate')
      console.log(htmlDom, htmlDom.clientWidth, htmlDom.clientHeight)
      html2canvas(htmlDom, {
        backgroundColor: '#ffffff',
        logging: false, //日志开关，便于查看html2canvas的内部执行流程
        width: htmlDom.clientWidth + 12, //dom 原始宽度
        height: htmlDom.clientHeight + 12,
        scrollY: 80,
        scrollX: 0,
        useCORS: true // 【重要】开启跨域配置
      }).then(canvas => {
        var imgData = canvas.toDataURL("image/png");
        this.fileDownload(imgData);
      })
    },
    fileDownload (downloadUrl) {
      let aLink = document.createElement("a");
      aLink.crossorigin = 'anonymous' // 解决图片跨域问题
      aLink.style.display = "none";
      aLink.href = downloadUrl;
      aLink.download = `${this.activeInfo.bankName}.png`;
      // 触发点击-然后移除
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink);
      this.removeLoading()
    }
  },
  created () {
    this.quoteList = this.$store.state.discountRate;

    Promise.all([this.refreshBankList(), this.getBestRate()]).then((res) => {
      this.loading = false;
      const [resRzline, bestRate] = res;
      console.log(bestRate, '=======');

      resRzline && this.cuBankList.push(...resRzline.data.data.map(item => {
        return {
          bankName: item.bankName,
          type: 'rzline',
          bankCode: item.bankCode,
          cuDiscountRate: item.cuDiscountRate || [],
          levelBankList: item.levelBankList || [],
          updateTime: item.updateTime || ''
        }
      }))
      let cuBestData = {
        bankName: bestRate.bankName,
        type: 'rzline',
        bankCode: bestRate.logo,
        cuDiscountRate: bestRate.cuDiscountRate,
        levelBankList: bestRate.levelBankList,
        updateTime: bestRate.updateTime
      }
      // 选择银行
      this.changeActiveBank(bestRate.bankName + '0', cuBestData)
    }).catch((err) => {
      console.log(err)
    })
  },
}
</script>
<style lang="scss" scoped>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.min-height {
  min-height: 500px;
}
.top-tab {
  display: flex;
  align-items: center;
  list-style: none;
  position: relative;
  margin-bottom: 30px;
  li {
    padding: 0 20px;
    position: relative;
    font-size: 14px;
    font-weight: 400;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 32px;
    .bank-color {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
    &.active {
      box-shadow: 2px 2px 8px 0px rgba(255, 124, 124, 0.71);
      border-radius: 8px;
    }
  }
}

.jdFont {
  font-family: 'jd-fonts';
}
</style>



// WEBPACK FOOTER //
// src/components/discountRate/DiscountGoodRateWebBase.vue